/**
 * The 32px sun-orb brand mark from STYLE_GUIDE.md §3.1.
 *
 * Extracted from the Phase 0 App.tsx so every page that shows the
 * wordmark (top bar, sign-in page hero, loading shell) uses the same
 * implementation.
 *
 * The gradient and glow are defined in globals.css under `.brand-mark`
 * because they're dense enough that inline Tailwind utility classes
 * would be unreadable. Here we just apply the class.
 */

interface Props {
  className?: string;
}

export function BrandMark({ className = "" }: Props) {
  return <div className={`brand-mark ${className}`} aria-hidden="true" />;
}
